import apiClient from './client';
import type { GuestJoinDiscriminatedRequest, GuestJoinResponse } from './types';

/**
 * Join a run as guest (spec 023 — explicit `mode` required).
 *
 * @param code The rallye join-code (6 chars, case-insensitive).
 * @param body Discriminated body: `{ mode: 'create', team_name, ... }`
 *             OR `{ mode: 'join', team_code, ... }`.
 */
export async function joinAsGuest(
  code: string,
  body: GuestJoinDiscriminatedRequest,
): Promise<GuestJoinResponse> {
  const { data } = await apiClient.post<GuestJoinResponse>(`/api/join/${code}`, body);
  return data;
}
